import React, { useState } from 'react';
import * as nsfwjs from 'nsfwjs';

function NSFWChecker() {
  const [text, setText] = useState('');
  const [isNSFW, setIsNSFW] = useState(null);
  const [error, setError] = useState(null);

  const loadModel = async () => {
    const model = await nsfwjs.load();
    return model;
  };

  const checkNSFW = async () => {
    try {
      const model = await loadModel();
      const predictions = await model.classify(text);
      
      // Assuming "Hentai" and "Sexy" are considered NSFW categories
      const nsfwCategories = ['Hentai', 'Sexy'];
      
      for (const prediction of predictions) {
        if (nsfwCategories.includes(prediction.className)) {
          setIsNSFW(true);
          return;
        }
      }
      
      setIsNSFW(false);
    } catch (err) {
      setError('Error checking NSFW: ' + err.message);
    }
  };

  return (
    <div>
      <h1>NSFW Checker</h1>
      
      <textarea
        placeholder="Enter text to check..."
        value={text}
        onChange={(e) => setText(e.target.value)}
      ></textarea>
      
      <button onClick={checkNSFW}>Check</button>
      
      {isNSFW !== null && (
        <p>
          The text is {isNSFW ? 'NSFW' : 'safe'}.
        </p>
      )}

      {error && <p style={{ color: 'red' }}>{error}</p>}
    </div>
  );
}

export default NSFWChecker;
